import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import parse from 'html-react-parser';

// utilities

import { configs } from '@constants/configs/configs';

// props

interface GAEPMainContentProps {
    titleId: string;
    mainContentId: string;
    mainContentSecondLineId: string;
    mainContentThirdLineId: string;
}

const GAEPMainContent = (props: GAEPMainContentProps) => {

    const intlApi = useIntl();

    const {
        routes: {
            ANON_GA_AGENTS,
            ANON_GA_CARRIERS,
            ANON_GA_GAEPS,
            HOME
        }
    } = configs;
    
    return (
        <Fragment>
            <div className={'gi-grid-container_panel'} id="main-content">
                <div className={'grid-row grid-container gi-grid-container'}>
                    <div className={'desktop:grid-col-12 tablet:grid-col-12 grid-col-12'}>
                        <h1><FormattedMessage id={props.titleId} /></h1>
                        <div className={'grid-row'}>
                            <p className={'body-display-spl-text'}>{parse(intlApi.formatMessage({ id: props.mainContentId }))}</p>
                            <p className={'body-display-spl-text'}>{parse(intlApi.formatMessage({ id: props.mainContentSecondLineId }))}</p>
                            <p className={'body-display-spl-text'}>{parse(intlApi.formatMessage({ id: props.mainContentThirdLineId }, { carriersURL: ANON_GA_CARRIERS, agentsURL: ANON_GA_AGENTS, gaepsURL: ANON_GA_GAEPS,homeURL: HOME }))}</p>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default GAEPMainContent;